import { render, staticRenderFns } from "./BlogTagInput.vue?vue&type=template&id=413e52f4&scoped=true&"
import script from "./BlogTagInput.vue?vue&type=script&lang=js&"
export * from "./BlogTagInput.vue?vue&type=script&lang=js&"
import style0 from "./BlogTagInput.vue?vue&type=style&index=0&id=413e52f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413e52f4",
  null
  
)

export default component.exports